import { render, staticRenderFns } from "./FormCurrencyTextField.vue?vue&type=template&id=3b4da53d&scoped=true&"
import script from "./FormCurrencyTextField.vue?vue&type=script&lang=js&"
export * from "./FormCurrencyTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4da53d",
  null
  
)

export default component.exports